export default __webpack_public_path__ + "static/media/flame_line_top.15ce18e5.svg";